import React, { useRef } from "react";
import { Button, Modal } from "react-bootstrap";
import ReactToPrint from "react-to-print";
import "../../../assets/scss/print-load.scss";
import { LoadPreviewData } from "./LoadPreviewData";

const LoadPrint = (props) => {
  const { load } = props;
  const componentRef = useRef();
  const pageStyle = `
    @page{
        padding: 10px;
    }`;
  return (
    <>
      <Modal.Body className="preview-body">
        <LoadPreviewData ref={componentRef} load={load} />
      </Modal.Body>
      <Modal.Footer className="preview-footer">
        <ReactToPrint
          trigger={() => <Button>Print</Button>}
          content={() => componentRef.current}
          pageStyle={pageStyle}
        />
      </Modal.Footer>
    </>
  );
};

export default LoadPrint;